import {createAction, createReducer} from '@reduxjs/toolkit'
import {takeLatest, getContext, put, call} from 'redux-saga/effects'
import Api, {UnauthorizedError} from 'Api'
import {actions as searchActions} from './search'

export type AssignmentsSummary = {
  activeAssignments: number
  devicesInInventory: number
}

export type AssignmentsSummaryState = {
  summary: AssignmentsSummary | undefined
  loading: boolean
  error: string | undefined
}

export const initialState: AssignmentsSummaryState = {
  summary: undefined,
  loading: false,
  error: undefined,
}

export const actions = {
  get: createAction('assignmentsSummary/get'),
  set: createAction<{summary: AssignmentsSummary}>('assignmentsSummary/set'),
  setLoading: createAction<{loading: boolean}>('assignmentsSummary/setLoading'),
  setError: createAction<{error?: string}>('assignmentsSummary/setError'),
}

export const reducer = createReducer(initialState, builder => {
  builder
    .addCase(actions.set, (state, action) => {
      state.summary = action.payload.summary
      state.loading = false
      state.error = undefined
    })
    .addCase(actions.setLoading, (state, action) => {
      state.loading = action.payload.loading
    })
    .addCase(actions.setError, (state, action) => {
      state.error = action.payload.error
      state.loading = false
    })
})

const getSaga = function*() {
  // Keeps any previous error until set() clears it, so Retry doesn't flash the stale cards.
  yield put(actions.setLoading({loading: true}))
  const api: Api = yield getContext('api')
  try {
    const summary: AssignmentsSummary = yield call(api.getAssignmentsSummary)
    yield put(actions.set({summary}))
  } catch (e) {
    const error = e as any
    if (error === UnauthorizedError) throw error
    yield put(actions.setError({error: error?.message ?? 'Error loading assignments summary'}))
  }
}

export const saga = function*() {
  // The header never remounts, so refetch on refreshSearch (dispatched by every mutating saga).
  yield takeLatest([actions.get, searchActions.refreshSearch], getSaga)
}
